export const transitions = {
  videoPlayer: 0.3,
  videoPlayerLong: 0.8,
  teleport: {
    joinLive: 4,
    leaveLive: 4,
  },
  player: {
    fadeIn: 1.5,
    fadeAfter: 2.5,
  },
};



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/theme/transitions.ts